export default __webpack_public_path__ + "static/1856-3e5c860ba2e2f681edaace481248e344.gif";